import React, { useEffect, useState } from "react"
import {
  Modal,
  Form,
  Input,
  DatePicker,
  InputNumber,
  Row,
  Col,
  Select,
  Space,
  message,
} from "antd"
import moment from "moment"
import axios from "axios"
import Button from "src/components/MyButton/Button"
import WarehouseService from "src/services/WarehouseService"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import SelectCountry from "src/components/Dropdown/SelectCountry"
import FormatMoney from "src/components/FormatMoney"
import SelectDiscountType from "src/components/Dropdown/SelectDiscountType"

const ModalCreateData = ({
  open,
  onCancel,
  refresh,
  onOk,
  record,
  onlyView = false,
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [countryId, setCountryId] = useState(null)
  const [totalAmount, setTotalAmount] = useState(0)
  const [finalAmount, setFinalAmount] = useState(0)

  const calculateAmounts = () => {
    console.log("tinh toan")
    const values = form.getFieldsValue()
    console.log(values)
    const price = parseFloat(values.unit_price) || 0
    const quantity = parseFloat(values.total_data) || 0
    const discountType = values.discount_type
    const discountValue = parseFloat(values.discount) || 0

    const total = price * quantity
    let final = total

    if (discountType === "percent") {
      final = total - (total * discountValue) / 100
    } else if (discountType === "fixed") {
      final = total - discountValue
    }

    setTotalAmount(total)
    setFinalAmount(final > 0 ? final : 0)
  }
  console.log(totalAmount, finalAmount, "kq toan")
  // Điền dữ liệu vào form khi record thay đổi
  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        ...record,
        import_date: moment(record.import_date),
      })
      calculateAmounts()
    } else {
      form.resetFields()
    }
  }, [record, form])

  // Xử lý submit form
  const handleSubmit = async values => {
    setLoading(true)
    try {
      const payload = {
        ...values,
        discount: parseInt(values.discount, 10),
        unit_price: parseInt(values.unit_price, 10),
        network_id: values.network_id,
        supplier_id: values.supplier_id,
        import_date: values.import_date.format("YYYY-MM-DD"),
        total_amount: totalAmount,
        total_discord: finalAmount,
      }
      // console.log(typeof values.unit_price, values.unit_price);
      let response
      if (record) {
        response = await WarehouseService.updateData(record.ID, payload)
      } else {
        response = await WarehouseService.createData(payload)
      }

      if (response.message) {
        message.success(response?.message)
        onOk?.()
        form.resetFields()
        onCancel?.()
      } else {
        message.error(record ? "Cập nhật thất bại!" : "Gửi duyệt thất bại!")
      }
    } catch (error) {
      console.error("Lỗi:", error)
      message.error("Có lỗi xảy ra, vui lòng thử lại!")
    } finally {
      setLoading(false)
    }
  }

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        handleSubmit(values)
      })
      .catch(error => {
        console.error("Lỗi validate form:", error)
      })
  }

  const handleCancel = () => {
    onCancel?.()
    message.info("Đã huỷ!")
  }
  return (
    <Modal
      title={"Tạo mới phiếu nhập kho"}
      open={open}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      onOk={handleOk}
      width={800}
      footer={
        <div
          className="ant-modal-footer"
          style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
        >
          <Button onClick={handleCancel}>Huỷ</Button>
          <Button btnType="primary1" onClick={handleOk} loading={loading}>
            {record ? "Cập nhật" : "Lưu"}
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical" onValuesChange={calculateAmounts}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nhà cung cấp"
              name="supplier_id"
              rules={[
                { required: true, message: "Vui lòng chọn nhà cung cấp" },
              ]}
            >
              <SelectProvider />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="country_id"
              label="Quốc gia"
              rules={[{ required: true, message: "Vui lòng chọn quốc gia" }]}
            >
              <SelectCountry
                disabled={onlyView}
                onChange={value => {
                  setCountryId(value)
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="network_id"
              label="Nhà mạng"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn nhà mạng",
                },
              ]}
            >
              <SelectCarrier disabled={onlyView} countryId={countryId} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Ngày nhập"
              name="import_date"
              rules={[{ required: true, message: "Vui lòng chọn ngày nhập" }]}
              initialValue={moment()}
            >
              <DatePicker style={{ width: "100%" }} format="DD-MM-YYYY" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Đơn giá Data"
              name="unit_price"
              rules={[
                { required: true, message: "Vui lòng nhập đơn giá data" },
              ]}
            >
              <InputNumber
                placeholder="Nhập đơn giá data"
                style={{ width: "100%" }}
                precision={0}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={value => value.replace(/\$\s?|(,*)/g, "")}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Dung lượng data"
              name="total_data"
              rules={[
                { required: true, message: "Vui lòng nhập Dung lượng data" },
              ]}
            >
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                placeholder="Nhập dung lượng"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="discount_type"
              label="Loại chiết khấu"
              rules={[
                { required: true, message: "Vui lòng chọn loại chiết khấu" },
              ]}
            >
              <Select placeholder="Chọn loại chiết khấu">
                <Select.Option value="percent">Chiết khấu %</Select.Option>
                <Select.Option value="fixed">Chiết khấu số tiền</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="discount"
              label="Chiết khấu"
              rules={[
                { required: true, message: "Vui lòng nhập chiết khấu" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const type = getFieldValue("discount_type")
                    if (type === "percent" && value > 100) {
                      return Promise.reject(
                        "Chiết khấu % không được vượt quá 100",
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <InputNumber
                placeholder="Nhập chiết khấu"
                style={{ width: "100%" }}
                min={0}
                onKeyPress={e => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault() // Chặn nhập chữ
                  }
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tổng tiền">
              <div style={{ fontWeight: "bold" }}>{totalAmount.toLocaleString("en-US")}</div>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Thành tiền sau chiết khấu">
              <div style={{ fontWeight: "bold", color: "#fa541c" }}>
                {finalAmount.toLocaleString("en-US")}
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default ModalCreateData
